export const API  = {

    get : async (endpoint) => {
        try {
            let response = await fetch(
                endpoint,
                {
                    method: 'GET',
                    headers: {
                        'Accept'      : 'application/json',
                        'Content-Type': 'application/json',
                    }
                }
            );
            return await response.json();
        } catch (error) {
            console.warn(error);
            return [];
        }
    },

    submit : async (data, endpoint) => {
        try {
            let form_data = API.create_form_data(data);

            let response = await fetch(
                endpoint,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                    },
                    body: form_data
                }
            );
            return await response.json();
        } catch (error) {
            console.warn(error);
            return [];
        }
    },


    create_form_data : (data) =>
    {
        const formData = new FormData();

        for(let property in data)
        {
            if(data[property] && data[property].fileList)
            {
                if(data[property].fileList.length === 0)
                    formData.append(`${property}[]`, '[]');
                else
                    data[property].fileList.forEach((file) => {
                        formData.append(`${property}`, file.originFileObj ? file.originFileObj : API.append_property(file));
                    });
            } else {
                formData.append(property, API.append_property(data[property]));
            }
        }

        return formData
    },

    append_property : (data) =>
    {
        if(data === null)
            return '$undefined$';

        return typeof data === 'object' ? JSON.stringify(data) : data
    }
};